import Vue from 'vue'
import conceptTransformer from '@/transformers/purchase/lifting/concepts'

/**
 * @author Jose Luis R
 * Fetches concepts from a quotation
 * @param id Quotation's id
 * @return {Object}
 */

const fetchConcepts = ({ id }) =>
  Vue.$http.get(`purchase/concept/${id}/`)
    .then((response) => {
      return conceptTransformer.fetchCollection(response.data).sort((a, b) => a.id - b.id)
    })
    .catch((err) => { throw err })

export default fetchConcepts



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/fetchConcepts.js